// import React from "react";
// import { getInitials } from "../../lib/util";
// import ImageComponent from "./ImageComponent";

// const InitialCard = ({ image, name }) => {
//   const containerStyle = {
//     display: "flex",
//     justifyContent: "center", // Horizontally center the image
//     height: "50px", // Set a height for the container
//     width: "50px", // Set the width of the container
//     border: "1px solid #ccc", // Optional: visual border for the container
//     overflow:"hidden",
//     borderRadius: '50%',
//   };
//   const imageStyle = {
//     width: "100%", // Ensure the image scales within the container
//    // maxHeight: "100%", // Maintain aspect ratio and prevent overflow
//     objectFit: "cover", // Keep the image contained within the boundaries
//   };
//   return (
//     <>
//       {image ? (
//         <div style={containerStyle}>
//           <ImageComponent src={image} style={imageStyle} quality={100} />
//         </div>
//       ) : (
//         <div className="initial-base">
//           <div className="label">{getInitials(name, 1)}</div>
//         </div>
//       )}
//     </>
//   );
// };

// export default InitialCard;

import React, { useState, useEffect } from "react";
import { getInitials } from "../../lib/util";
import ImageComponent from "./ImageComponent";

const InitialCard = ({ image, name }) => {
  const [loading, setLoading] = useState(true);
  const [currentSrc, setCurrentSrc] = useState(image);

  useEffect(() => {
    if (image && image !== currentSrc) {
      setLoading(true);
      setCurrentSrc(image);
    }
  }, [image]);

  const containerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "50px",
    width: "50px",
    border: "1px solid #ccc",
    overflow: "hidden",
    borderRadius: "50%",
    position: "relative",
  };

  const imageStyle = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    opacity: loading ? 0 : 1,
    transition: "opacity 0.2s ease-in-out",
  };

  const skeletonStyle = {
    position: "absolute",
    height: "100%",
    width: "100%",
    borderRadius: "50%",
    background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
    backgroundSize: "200% 100%",
    animation: "shimmer 1.2s infinite",
  };

  return (
    <>
      {image ? (
        <div style={containerStyle}>
          {loading && <div style={skeletonStyle} />}

          <ImageComponent
            key={currentSrc} // Forces re-render when src changes
            src={currentSrc}
            style={imageStyle}
            quality={100}
            onLoad={() => setLoading(false)}
          />
        </div>
      ) : (
        <div className="initial-base">
          <div className="label">{getInitials(name, 1)}</div>
        </div>
      )}

      <style>
        {`
          @keyframes shimmer {
            0% { background-position: -200% 0; }
            100% { background-position: 200% 0; }
          }
        `}
      </style>
    </>
  );
};

export default InitialCard;
